<template>
  <div class="invite-required-page">
    <div class="card">
      <h2>填写邀请码</h2>
      <p class="lead">本站注册需要有效邀请码。请向邀请人索取 8 位邀请码并填写后继续。</p>

      <el-form @submit.prevent="submit">
        <el-form-item label="邀请码">
          <el-input
            v-model="inviteCode"
            placeholder="请输入邀请码"
            maxlength="32"
            autocomplete="off"
            @blur="checkInviteCode"
          />
        </el-form-item>
        <p v-if="inviteHint" class="hint" :class="{ error: hintError }">{{ inviteHint }}</p>
        <el-button type="primary" :loading="submitting" @click="submit">确认并继续</el-button>
        <el-button link type="info" @click="logout">退出登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authManager from '@/utils/auth'
import { bindInviteCode } from '@/utils/inviteConfig'

export default {
  name: 'InviteCodeRequiredView',
  data() {
    return {
      inviteCode: '',
      inviteHint: '',
      hintError: false,
      submitting: false
    }
  },
  created() {
    const q = this.$route.query.invite
    if (typeof q === 'string' && q.trim()) {
      this.inviteCode = q.trim()
      this.checkInviteCode()
    }
  },
  methods: {
    async checkInviteCode() {
      const code = (this.inviteCode || '').trim()
      if (!code) {
        this.inviteHint = ''
        this.hintError = false
        return
      }
      try {
        const res = await axios.get('/api/v1/invite/code/check', { params: { code } })
        const data = res.data?.data
        if (data?.valid) {
          this.inviteHint = data.ownerNickname
            ? `邀请人：${data.ownerNickname}，邀请码可用`
            : '邀请码可用'
          this.hintError = false
        } else {
          this.inviteHint = data?.message || '邀请码无效'
          this.hintError = true
        }
      } catch {
        this.inviteHint = ''
        this.hintError = false
      }
    },
    async submit() {
      const code = (this.inviteCode || '').trim()
      if (!code) {
        this.$message.error('请填写邀请码')
        return
      }
      this.submitting = true
      try {
        await bindInviteCode(code)
        this.$message.success('邀请码绑定成功')
        const redirect = typeof this.$route.query.href === 'string' ? this.$route.query.href : '/'
        this.$router.replace(redirect.startsWith('/') ? redirect : '/')
      } catch (err) {
        this.$message.error(err.message || '绑定失败')
        await this.checkInviteCode()
      } finally {
        this.submitting = false
      }
    },
    logout() {
      authManager.logout()
      this.$root.logout?.()
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.invite-required-page {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: #f5f7fa;
}
.card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
h2 {
  margin: 0 0 8px;
  font-size: 1.35rem;
}
.lead {
  margin: 0 0 24px;
  color: #606266;
  font-size: 0.95rem;
  line-height: 1.6;
}
.hint {
  margin: -8px 0 16px;
  font-size: 13px;
  color: #67c23a;
}
.hint.error {
  color: #f56c6c;
}
</style>
